import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { Box, Grid, TextField } from '@material-ui/core';

import GuideMessage from '../message/GuideMessage';
import { makeStyles } from '@material-ui/core/styles';
import { CustomButton, CustomVacantButton } from '../button';
import { PhoneVerify } from '../verify';
import { EmailRegExp } from '../../lib/util';

let params = {};
function PWInquiryForm({ handleIdentifyBtn, loginStore }) {
  const history = useHistory();
  const classes = useStyles();
  const { findPwdCall, phoneInitial, setPhoneVerified } = loginStore;
  const [verifiedUid, setVerifiedUid] = useState('');

  useEffect(() => {
    phoneInitial();
  }, [])

  const handleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    params[name] = value;
  }

  // 이메일 + 휴대폰 인증이 모두 끝나면 비밀번호 재설정 단계로
  const onSubmit = () => {
    if (!params.email) {
      alert("이메일을 입력하세요.");
      return;
    } else if (!EmailRegExp(params.email)) {
      alert("이메일을 정확히 입력하세요.");
      return;
    } else if (!verifiedUid) {
      alert("휴대폰 인증을 완료해 주세요.");
      return;
    }
    setPhoneVerified(verifiedUid);
    findPwdCall(params, () => handleIdentifyBtn('change'));
  }
  
  return (
    <React.Fragment>
      <Grid container direction="row" justify="center" wrap="nowrap" className={classes.pwInquiryWrap}>
        <Grid item className="loginFormArea">
          <Grid container direction="column" justify="center" className="narrowFormArea">
            <Grid item>
              <Grid container direction="column" justify="center" alignItems="center">
                <GuideMessage
                  title="비밀번호를 잊어버리셨나요?"
                  resultTitle="비밀번호를 잊어버리셨나요?"
                  mTitle="비밀번호찾기"
                  subTitle="간단한 정보 확인 후 안내를 도와드릴게요."
                />
              </Grid>
            </Grid>
            <Grid item className={classes.inputForm}>
              <Box className="mainFormGroup">
                <TextField
                  placeholder="가입한 아이디(e-mail)"
                  variant="outlined"
                  fullWidth
                  className="formArea"
                  name="email"
                  onChange={handleChange}
                />
              </Box>
              <PhoneVerify purpose="findPwd" onVerified={(uid) => setVerifiedUid(uid)} />
            </Grid>
            <Grid item>
              <CustomButton
                fullWidth
                variant="contained"
                color="primary"
                onClick={onSubmit}
                >비밀번호 재설정
              </CustomButton>
              <CustomVacantButton
                fullWidth
                variant="contained"
                color="secondary"
                className={classes.signupBtn}
                onClick={() => history.push("/signup")}
              >초간단 회원가입
              </CustomVacantButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  pwInquiryWrap: {
    paddingTop: 100,
    paddingBottom: 120
  },
  pwInquiryForm: {
    width: 420,
    marginLeft: 20,
    marginRight: 20,
  },
  inputForm: {
    padding: '60px 0'
  },
  signupBtn: {
    marginTop: 20,
  },
  button: {
    width: 96,
    height: 53,
    borderRadius: 8,
    padding: 0,
    backgroundColor: '#e4e4e9',
    position: 'absolute',
    right: 0,
    color: '#fff',
    fontSize: 16,
    boxShadow: 'none'
  },
}));

export default inject('loginStore')(observer(PWInquiryForm));